// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Unified Card Grid Styles - Used across Orders, Users, Complaints */

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 20px;
  margin-top: 10px;
}

/* Вне экрана браузер может пропускать отрисовку карточек (лучше скролл на Users/Orders) */
.cards-grid > a.item-card,
.cards-grid > .item-card {
  content-visibility: auto;
  contain-intrinsic-size: auto 220px;
}

.item-card {
  background: var(--bg-secondary);
  border-radius: 10px;
  padding: 12px 14px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  height: 100%;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  text-align: left;
  /* Force left alignment universally */
}

@media (hover: hover) and (pointer: fine) {
  .item-card:hover {
    border-color: var(--accent-primary);
    box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.1);
    background: var(--bg-primary);
  }
}

.item-card .card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 0 10px 0 !important;
  border-bottom: 1px solid var(--border-color);
  margin: 0 0 10px 0 !important;
  min-height: 60px;
  /* Consistent height for up to 2 lines of name */
}

.item-card .card-title {
  font-family: var(--font-heading) !important;
  font-size: 1.1rem !important;
  font-weight: 700 !important;
  color: var(--text-heading);
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.3;
  flex: 1 1;
  min-width: 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  overflow: hidden;
}

.title-id-tag {
  font-family: var(--font-data);
  font-size: 0.85rem;
  color: var(--text-secondary);
  font-weight: 500;
  margin-left: 4px;
}

/* Avatar Styles */
.user-avatar-container {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #3b82f6, #60a5fa);
  border: 2px solid rgba(255, 255, 255, 0.8);
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.users-page .user-avatar-container.status-active {
  border-color: rgba(255, 255, 255, 0.8);
}

.users-page .user-avatar-container.status-inactive {
  border-color: rgba(255, 255, 255, 0.8);
}

.users-page .user-avatar-container.status-blocked {
  border-color: rgba(255, 255, 255, 0.8);
}

.users-page .user-avatar-container {
  overflow: visible;
}

.users-page .user-avatar-container .user-avatar-img,
.users-page .user-avatar-container .user-avatar-initial {
  border-radius: 50%;
}

.users-page .user-avatar-container .status-dot {
  width: 12px;
  height: 12px;
  border: 2px solid #fff;
  border-radius: 50%;
  position: absolute;
  bottom: -2px;
  right: -2px;
  z-index: 2;
}

.users-page .user-avatar-container .status-dot.status-active {
  background-color: #2ecc71;
  box-shadow: 0 0 5px rgba(46, 204, 113, 0.5);
}

.users-page .user-avatar-container .status-dot.status-inactive {
  background-color: #f59e0b;
  box-shadow: 0 0 5px rgba(245, 158, 11, 0.5);
}

.users-page .user-avatar-container .status-dot.status-blocked {
  background-color: #ef4444;
  box-shadow: 0 0 5px rgba(239, 68, 68, 0.5);
}

.user-avatar-initial {
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transform: translateY(1px);
}

.user-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Copiable Text */
.copiable-text {
  border-bottom: 1px dashed rgba(148, 163, 184, 0.4);
  transition: all 0.2s ease;
  cursor: pointer;
}

.copiable-text:hover {
  border-bottom-color: var(--accent-primary);
  color: var(--accent-primary);
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
  text-align: left;
}

.card-description {
  font-size: 0.825rem;
  color: var(--text-secondary);
  line-height: 1.4;
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: auto;
  max-height: calc(3 * 1.4 * 0.825rem);
  /* Exactly 3 lines */
  min-height: 0;
}

.card-empty {
  color: var(--text-secondary);
  opacity: 0.5;
  font-style: italic;
}

/* Metadata Mini Grid */
.card-details-mini-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px dashed var(--border-color);
}

.card-detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.7rem;
  color: var(--text-secondary);
}

.card-detail-icon {
  color: var(--accent-primary);
  opacity: 0.8;
  flex-shrink: 0;
  display: block;
  margin-top: 0;
}

.card-detail-text {
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text-primary);
  word-break: break-all;
  line-height: 1.4;
  flex: 1 1;
  min-width: 0;
}

.card-detail-text.mono {
  font-family: var(--font-data);
  letter-spacing: -0.2px;
  font-size: 0.75rem;
  opacity: 0.9;
}

.card-detail-text.role-text {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  opacity: 0.85;
  color: var(--text-secondary);
}

.role-row .card-detail-icon {
  margin-top: 0px;
  /* Less margin for small all-caps role text */
}

/* Card Footer */
.card-footer {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 6px;
}

.card-footer-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-date {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  color: var(--text-secondary);
  font-weight: 500;
  line-height: 1;
}

.card-date-icon {
  opacity: 0.6;
  transform: translateY(-0.5px);
}

/* Rating Mini Styles */
.rating-mini {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-data);
  line-height: normal;
}

.mini-stars {
  display: flex;
  gap: 2px;
  font-size: 0.85rem;
  transform: translateY(-1px);
  /* Lifted by 2px from the previous +1px */
  line-height: 1;
  color: #f59e0b;
  /* Matching UserDetails color */
}

.mini-stars .star-full {
  color: #f59e0b !important;
}

.mini-stars .star-empty {
  color: #e2e8f0 !important;
}

.rating-value-mini {
  font-weight: 700;
  color: var(--text-primary);
  font-size: 0.7rem;
}

.rating-count-mini {
  color: var(--text-secondary);
  font-size: 0.7rem;
  opacity: 0.7;
}

/* Header Badge Specifics */
.user-plan-tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.64rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.user-plan-tag.pro {
  background: #eff6ff;
  color: #2563eb;
}

.user-plan-tag.premium {
  background: #faf5ff;
  color: #7c3aed;
}

.user-plan-tag.basic {
  background: #f1f5f9;
  color: #475569;
}

/* Body Rows Layout */
.card-body-rows {
  display: flex;
  flex-direction: column;
}

.card-main-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  /* Centers detail rows between the two horizontal lines */
  min-height: 160px;
  /* Ensures the second divider is always in the same place even with multi-line content */
}

.card-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: stretch;
}

.card-row.role-row {
  margin-top: 6px;
  padding-top: 10px;
  border-top: 1px solid var(--border-color);
}

.card-row-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  width: 100%;
  position: relative;
}

.card-row-item.right {
  justify-content: flex-start;
}

/* Copy Button */
.copy-badge-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  position: relative;
}

.copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 4px;
  opacity: 0.6;
  transition: all 0.2s ease;
}

.card-row-item:hover .copy-btn,
.card-detail-item:hover .copy-btn,
.card-description:hover .copy-btn {
  opacity: 0.85;
}

.copy-btn:hover {
  background: var(--surface-secondary);
  opacity: 1 !important;
  color: var(--accent-primary);
}

.copy-btn.copied {
  color: #10b981;
  /* Success Green */
  opacity: 1 !important;
}

.card-empty {
  color: var(--text-secondary);
  opacity: 0.4;
  font-style: italic;
  font-size: 0.75rem;
}

/* Footer Right Content */
.card-footer-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.footer-comment-count {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  color: var(--text-secondary);
  font-weight: 600;
  opacity: 0.8;
}

/* Responsive Grid Adjustments */
@media (max-width: 1200px) {
  .cards-grid {
    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  }
}

@media (max-width: 900px) {
  .cards-grid {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
  }
}

@media (max-width: 600px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }
}
/* Тёмная тема (DEV): светлый тег тарифа и слишком светлые «пустые»
   звёзды рейтинга. */
:root[data-theme='dark'] .user-plan-tag.basic {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

:root[data-theme='dark'] .mini-stars .star-empty {
  color: #475569 !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/cards.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA,0FAA0F;AAC1F;;EAEE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ;;;8BAG4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,mCAAmC;IACnC,8CAA8C;IAC9C,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,4CAA4C;EAC5C,6BAA6B;EAC7B,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,0CAA0C;EAC1C,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,kDAAkD;EAClD,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,6CAA6C;AAC/C;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,yCAAyC;EACzC,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,yDAAyD;EACzD,iBAAiB;EACjB,wFAAwF;AAC1F;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;qBACqB;AACrB;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Unified Card Grid Styles - Used across Orders, Users, Complaints */\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));\n  gap: 20px;\n  margin-top: 10px;\n}\n\n/* Вне экрана браузер может пропускать отрисовку карточек (лучше скролл на Users/Orders) */\n.cards-grid > a.item-card,\n.cards-grid > .item-card {\n  content-visibility: auto;\n  contain-intrinsic-size: auto 220px;\n}\n\n.item-card {\n  background: var(--bg-secondary);\n  border-radius: 10px;\n  padding: 12px 14px;\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease,\n    background-color 0.2s ease;\n  position: relative;\n  overflow: hidden;\n  text-decoration: none;\n  color: inherit;\n  text-align: left;\n  /* Force left alignment universally */\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .item-card:hover {\n    border-color: var(--accent-primary);\n    box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.1);\n    background: var(--bg-primary);\n  }\n}\n\n.item-card .card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 0 10px 0 !important;\n  border-bottom: 1px solid var(--border-color);\n  margin: 0 0 10px 0 !important;\n  min-height: 60px;\n  /* Consistent height for up to 2 lines of name */\n}\n\n.item-card .card-title {\n  font-family: var(--font-heading) !important;\n  font-size: 1.1rem !important;\n  font-weight: 700 !important;\n  color: var(--text-heading);\n  margin: 0 !important;\n  padding: 0 !important;\n  line-height: 1.3;\n  flex: 1;\n  min-width: 0;\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  overflow: hidden;\n}\n\n.title-id-tag {\n  font-family: var(--font-data);\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n  margin-left: 4px;\n}\n\n/* Avatar Styles */\n.user-avatar-container {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #3b82f6, #60a5fa);\n  border: 2px solid rgba(255, 255, 255, 0.8);\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.users-page .user-avatar-container.status-active {\n  border-color: rgba(255, 255, 255, 0.8);\n}\n\n.users-page .user-avatar-container.status-inactive {\n  border-color: rgba(255, 255, 255, 0.8);\n}\n\n.users-page .user-avatar-container.status-blocked {\n  border-color: rgba(255, 255, 255, 0.8);\n}\n\n.users-page .user-avatar-container {\n  overflow: visible;\n}\n\n.users-page .user-avatar-container .user-avatar-img,\n.users-page .user-avatar-container .user-avatar-initial {\n  border-radius: 50%;\n}\n\n.users-page .user-avatar-container .status-dot {\n  width: 12px;\n  height: 12px;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  z-index: 2;\n}\n\n.users-page .user-avatar-container .status-dot.status-active {\n  background-color: #2ecc71;\n  box-shadow: 0 0 5px rgba(46, 204, 113, 0.5);\n}\n\n.users-page .user-avatar-container .status-dot.status-inactive {\n  background-color: #f59e0b;\n  box-shadow: 0 0 5px rgba(245, 158, 11, 0.5);\n}\n\n.users-page .user-avatar-container .status-dot.status-blocked {\n  background-color: #ef4444;\n  box-shadow: 0 0 5px rgba(239, 68, 68, 0.5);\n}\n\n.user-avatar-initial {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: white;\n  line-height: 1;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  transform: translateY(1px);\n}\n\n.user-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Copiable Text */\n.copiable-text {\n  border-bottom: 1px dashed rgba(148, 163, 184, 0.4);\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.copiable-text:hover {\n  border-bottom-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-grow: 1;\n  text-align: left;\n}\n\n.card-description {\n  font-size: 0.825rem;\n  color: var(--text-secondary);\n  line-height: 1.4;\n  display: -webkit-box !important;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  height: auto;\n  max-height: calc(3 * 1.4 * 0.825rem);\n  /* Exactly 3 lines */\n  min-height: 0;\n}\n\n.card-empty {\n  color: var(--text-secondary);\n  opacity: 0.5;\n  font-style: italic;\n}\n\n/* Metadata Mini Grid */\n.card-details-mini-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: auto;\n  padding-top: 8px;\n  border-top: 1px dashed var(--border-color);\n}\n\n.card-detail-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n}\n\n.card-detail-icon {\n  color: var(--accent-primary);\n  opacity: 0.8;\n  flex-shrink: 0;\n  display: block;\n  margin-top: 0;\n}\n\n.card-detail-text {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  word-break: break-all;\n  line-height: 1.4;\n  flex: 1;\n  min-width: 0;\n}\n\n.card-detail-text.mono {\n  font-family: var(--font-data);\n  letter-spacing: -0.2px;\n  font-size: 0.75rem;\n  opacity: 0.9;\n}\n\n.card-detail-text.role-text {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  opacity: 0.85;\n  color: var(--text-secondary);\n}\n\n.role-row .card-detail-icon {\n  margin-top: 0px;\n  /* Less margin for small all-caps role text */\n}\n\n/* Card Footer */\n.card-footer {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding-top: 6px;\n}\n\n.card-footer-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.card-date {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n  line-height: 1;\n}\n\n.card-date-icon {\n  opacity: 0.6;\n  transform: translateY(-0.5px);\n}\n\n/* Rating Mini Styles */\n.rating-mini {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--font-data);\n  line-height: normal;\n}\n\n.mini-stars {\n  display: flex;\n  gap: 2px;\n  font-size: 0.85rem;\n  transform: translateY(-1px);\n  /* Lifted by 2px from the previous +1px */\n  line-height: 1;\n  color: #f59e0b;\n  /* Matching UserDetails color */\n}\n\n.mini-stars .star-full {\n  color: #f59e0b !important;\n}\n\n.mini-stars .star-empty {\n  color: #e2e8f0 !important;\n}\n\n.rating-value-mini {\n  font-weight: 700;\n  color: var(--text-primary);\n  font-size: 0.7rem;\n}\n\n.rating-count-mini {\n  color: var(--text-secondary);\n  font-size: 0.7rem;\n  opacity: 0.7;\n}\n\n/* Header Badge Specifics */\n.user-plan-tag {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.64rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.user-plan-tag.pro {\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.user-plan-tag.premium {\n  background: #faf5ff;\n  color: #7c3aed;\n}\n\n.user-plan-tag.basic {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n/* Body Rows Layout */\n.card-body-rows {\n  display: flex;\n  flex-direction: column;\n}\n\n.card-main-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  justify-content: center;\n  /* Centers detail rows between the two horizontal lines */\n  min-height: 160px;\n  /* Ensures the second divider is always in the same place even with multi-line content */\n}\n\n.card-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: stretch;\n}\n\n.card-row.role-row {\n  margin-top: 6px;\n  padding-top: 10px;\n  border-top: 1px solid var(--border-color);\n}\n\n.card-row-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  width: 100%;\n  position: relative;\n}\n\n.card-row-item.right {\n  justify-content: flex-start;\n}\n\n/* Copy Button */\n.copy-badge-wrapper {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  position: relative;\n}\n\n.copy-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 4px;\n  opacity: 0.6;\n  transition: all 0.2s ease;\n}\n\n.card-row-item:hover .copy-btn,\n.card-detail-item:hover .copy-btn,\n.card-description:hover .copy-btn {\n  opacity: 0.85;\n}\n\n.copy-btn:hover {\n  background: var(--surface-secondary);\n  opacity: 1 !important;\n  color: var(--accent-primary);\n}\n\n.copy-btn.copied {\n  color: #10b981;\n  /* Success Green */\n  opacity: 1 !important;\n}\n\n.card-empty {\n  color: var(--text-secondary);\n  opacity: 0.4;\n  font-style: italic;\n  font-size: 0.75rem;\n}\n\n/* Footer Right Content */\n.card-footer-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.footer-comment-count {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  font-weight: 600;\n  opacity: 0.8;\n}\n\n/* Responsive Grid Adjustments */\n@media (max-width: 1200px) {\n  .cards-grid {\n    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  }\n}\n\n@media (max-width: 900px) {\n  .cards-grid {\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 12px;\n  }\n}\n\n@media (max-width: 600px) {\n  .cards-grid {\n    grid-template-columns: 1fr;\n  }\n}\n/* Тёмная тема (DEV): светлый тег тарифа и слишком светлые «пустые»\n   звёзды рейтинга. */\n:root[data-theme='dark'] .user-plan-tag.basic {\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n}\n\n:root[data-theme='dark'] .mini-stars .star-empty {\n  color: #475569 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
